var consts = {
    CODE_993: "993",
    CODE_050: "050",
    CODE_051: "051",

    // http前缀
    HTTP_PREFIX: "http://",

    // 冒号
    SYMBOL_COLON: ":",

    /** 产品设置页面跳转路径*/
    // 云柜
    SETTING_VIEW_SUFFIX_201: "/#/login?routerName=P20100&moduleId=M00006",
    // 易诉柜
    SETTING_VIEW_SUFFIX_202: "/#/login?routerName=cabinetCabinetIndex&moduleId=M00002",
    // 记名柜
    SETTING_VIEW_SUFFIX_203: "/#/login?routerName=P20073&moduleId=M00010",
    // 精简版云柜
    SETTING_VIEW_SUFFIX_205: "/#/login?routerName=p20115&moduleId=M00012",
    // 法官M箱
    SETTING_VIEW_SUFFIX_206: "/#/login?routerName=P10199&moduleId=M00013",
    // 虚拟柜
    SETTING_VIEW_SUFFIX_211: "/#/login?routerName=P20084&moduleId=M00007",
    // 中间柜
    SETTING_VIEW_SUFFIX_401: "/#/login?routerName=warehouseIndex&moduleId=M00003",
    // 中间库
    SETTING_VIEW_SUFFIX_402: "/#/login?routerName=warehouseIndex&moduleId=M00004",
    // 交转柜
    SETTING_VIEW_SUFFIX_601: "/#/login?routerName=warehouseIndex&moduleId=M00014",

    // 基础数据最新版本号
    CONFIG_CODE_001: "001",

    // 设备系统
    DEVICE_OS_CODE: "015",

    // 设备系统 -window
    DEVICE_OS_CODE_001: "windows",

    // 设备系统 -android
    DEVICE_OS_CODE_002: "android",

    // 设备类型
    DEVICE_TYPE_CODE: "014",

    // 设备系统 -一体机
    DEVICE_TYPE_CODE_001: "一体机",

    // 设备系统 -一体机
    DEVICE_TYPE_CODE_002: "一体机",

    // 江苏省法院个数
    JIANG_SU_COURT_NUMBER: 124,

    // 辽宁省法院个数
    LIAO_NING_COURT_NUMBER: 132,

    // 安徽省法院个数
    AN_HUI_COURT_NUMBER: 137,

    // 福建省法院个数
    FU_JIAN_COURT_NUMBER: 99,

    // 广东省法院个数
    GUANG_DONG_COURT_NUMBER: 156,

    // 海南省法院个数
    HAI_NAN_COURT_NUMBER: 28,

    // 山东省法院个数
    SHAN_DONG_COURT_NUMBER: 169,

    // 陕西省法院个数
    SHAN_XI_COURT_NUMBER: 318,

    // 上海法院个数
    SHANG_HAI_COURT_NUMBER: 28,

    // 云南法院个数
    YUN_NAN_COURT_NUMBER: 148,

    // 浙江法院个数
    ZHE_JIANG_COURT_NUMBER: 103,

    // 吉林法院个数
    JI_LIN_COURT_NUMBER: 98,

    // 河南法院个数
    HE_NAN_COURT_NUMBER: 189,

    // 山西法院个数
    SHAN_XI_COURT_NUMBER_01: 135,

    // 广西法院个数
    GUANG_XI_COURT_NUMBER: 130,

    // 四川法院个数
    SI_CHUAN_COURT_NUMBER: 211,

    // 内蒙古法院个数
    NEI_MENG_GU_COURT_NUMBER: 118,

    // 河北省法院个数
    HE_BEI_COURT_NUMBER: 328,

    // 黑龙江法院个数
    HEI_LONG_JIANG_COURT_NUMBER: 195,

    // 贵州法院个数
    GUI_ZHOU_COURT_NUMBER: 338,

    // 甘肃法院个数
    GAN_SU_COURT_NUMBER: 113,

    // 宁夏法院个数
    NING_XIA_COURT_NUMBER: 29,

    // 青海法院个数
    QING_HAI_COURT_NUMBER: 57,

    // 北京法院个数
    BEI_JING_COURT_NUMBER: 23,

    // 重庆法院个数
    CHONG_QING_COURT_NUMBER: 44,

    // 天津法院个数
    TIAN_JING_COURT_NUMBER: 23,

    LICENSE_TYPE_001: "001",
    LICENSE_TYPE_002: "002",
}
export default consts



// WEBPACK FOOTER //
// ./src/utils/bizConstant.js